<template>
  <div class="login-wrapper">
    Logging you out...
    <div class="loading">
      <v-progress-circular
        indeterminate
        color="primary"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Logout',
  mounted() {
    this.triggerLogout();
  },
  methods: {
    async triggerLogout() {
      await this.$store.commit('logOutUser');
      setTimeout(() => {
        this.$router.push({ path: '/login' });
      }, 1000);
    },
  },
};
</script>

<style lang="scss" scoped>
.loading {
  display: block;
  position: relative;
  margin-top: 1em;
}

.login-wrapper {
  text-align: center;
}
</style>
